import React from "react";
import { 
  FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube,
  FaPhoneAlt, FaEnvelope, FaMapMarkerAlt 
} from "react-icons/fa";
import { HiOutlineArrowRight } from "react-icons/hi2";
import logo from "../asset/img/logo.png";
import "../asset/css/footer.css";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="container">
        {/* Newsletter / Subscription Box */}
        <div className="footer-newsletter shadow-lg">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h3 className="text-white mb-2 mb-lg-0">Subscribe to our newsletter for latest updates</h3>
            </div>
            <div className="col-lg-6">
              <div className="input-group subscribe-form">
                <input type="email" className="form-control" placeholder="Enter your email" />
                <button className="btn btn-subscribe" type="button">Subscribe</button>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-content pt-5 pb-4">
          <div className="row g-4">
            {/* Column 1: Brand & Bio */}
            <div className="col-lg-4 col-md-6">
              <div className="footer-brand mb-4">
                <img src={logo} alt="TopAir Logo" className="footer-logo mb-3" />
                <p className="text-muted">
                TopAirView is a trusted tour and travel company delivering seamless, memorable journeys. From customized itineraries to comfortable transportation and expert guidance, we ensure hassle-free travel experiences. Whether leisure or business, domestic or international, TopAirView turns every trip into a perfectly planned adventure.
                </p>
              </div>
              <div className="footer-socials d-flex gap-3">
                <a href="#" className="social-icon"><FaFacebookF /></a>
                <a href="#" className="social-icon"><FaTwitter /></a>
                <a href="#" className="social-icon"><FaInstagram /></a>
                <a href="#" className="social-icon"><FaLinkedinIn /></a>
                <a href="#" className="social-icon"><FaYoutube /></a>
              </div>
            </div>

            {/* Column 2: Quick Links */}
            <div className="col-lg-2 col-md-6 col-6">
              <h5 className="footer-title">Quick Links</h5>
              <ul className="footer-links list-unstyled">
                <li><a href="#"><HiOutlineArrowRight className="me-2"/> Home</a></li>
                <li><a href="#"><HiOutlineArrowRight className="me-2"/> About Us</a></li>
                <li><a href="#"><HiOutlineArrowRight className="me-2"/> Packages</a></li>
                <li><a href="#"><HiOutlineArrowRight className="me-2"/> Cabs</a></li>
                <li><a href="#"><HiOutlineArrowRight className="me-2"/> Contact</a></li>
              </ul>
            </div>

            {/* Column 3: Services */}
            <div className="col-lg-2 col-md-6 col-6">
              <h5 className="footer-title">Our Services</h5>
              <ul className="footer-links list-unstyled">
                <li><a href="#"><HiOutlineArrowRight className="me-2"/> Flight Booking</a></li>
                <li><a href="#"><HiOutlineArrowRight className="me-2"/> Hotel Booking</a></li>
                <li><a href="#"><HiOutlineArrowRight className="me-2"/> Bus Tickets</a></li>
                <li><a href="#"><HiOutlineArrowRight className="me-2"/> DTH Top-Up</a></li>
                <li><a href="#"><HiOutlineArrowRight className="me-2"/> Bill Payments</a></li>
              </ul>
            </div>

            {/* Column 4: Contact Info */}
            <div className="col-lg-4 col-md-6">
              <h5 className="footer-title">Contact Us</h5>
              <div className="contact-info">
                <div className="d-flex align-items-center mb-3">
                  <div className="contact-icon me-3"><FaPhoneAlt /></div>
                  <span>+91 9412991272 ,
+91 9897373444</span>
                </div>
                <div className="d-flex align-items-center mb-3">
                  <div className="contact-icon me-3"><FaEnvelope /></div>
                  <span>a2zyatra2012@gmail.com</span>
                </div>
                <div className="d-flex align-items-center">
                  <div className="contact-icon me-3"><FaMapMarkerAlt /></div>
                  <span>Bholagiri Road, Haridwar, Uttrakhand (249401)</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom border-top py-4 text-center">
          <p className="mb-0 text-muted small">
            &copy; 2026 <strong>TopAir View</strong>. All Rights Reserved. 
            Powered by Motherwit Digital Solutions
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;